import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { LiveningElectricityConnectionPage, LiveningElectricityConnectionPageProps } from "./LiveningElectricityConnectionPage";

export const EMPTY_PAGE_CONTENT: LiveningElectricityConnectionPageProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/electricity/new-connection/livening";

export const LiveningElectricityConnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<LiveningElectricityConnectionPageProps>("livening_electricity_connection", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <LiveningElectricityConnectionPage {...routeProps} {...content} />;
};
